<!--  -->
<template>
    <div>
    
    </div>
</template>
<script>
export default {
    data() {
        return {}
    },
    created() {},
    mounted() {}
}
</script>
<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// src/views/tourActivity.vue